/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { JobExecutionDetails } from '../models/JobExecutionDetails';
import { ResourceDetails } from '../models/ResourceDetails';
import { ScanJobType } from '../models/ScanJobType';

export class ScanJob {
  'jobExecutionDetails': JobExecutionDetails;
  'resourceDetails'?: ResourceDetails | null;
  'scanType': ScanJobType;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobExecutionDetails",
      "baseName": "jobExecutionDetails",
      "type": "JobExecutionDetails",
      "format": ""
    },
    {
      "name": "resourceDetails",
      "baseName": "resourceDetails",
      "type": "ResourceDetails",
      "format": ""
    },
    {
      "name": "scanType",
      "baseName": "scanType",
      "type": "ScanJobType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ScanJob.attributeTypeMap;
  }

  public constructor() {
  }
}



